var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as XLSX from 'xlsx';
import { downloadBlob } from '../../../utils/commonUtilities';
import { toResubmitRowViewModel } from './resubmitRowMapper';
var getGridColumns = function (isReqDocsStage) { return ([
    { key: 'contractIdDisplay', label: isReqDocsStage ? 'Transaction ID' : 'S.No.' },
    { key: 'customerName', label: 'Customer' },
    { key: 'portalName', label: 'Portal' },
    { key: 'dealerSalesRepName', label: 'Dealer Sales Rep' },
    { key: 'applicationDate', label: 'Application Date' },
    { key: 'errorMessage', label: 'Error Message' },
    { key: 'status', label: 'Status' },
]); };
var asArray = function (value) { return (Array.isArray(value) ? value : value ? [value] : []); };
var flattenForExport = function (value, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var rows = [];
    if (Array.isArray(value)) {
        value.forEach(function (item, index) {
            rows.push.apply(rows, flattenForExport(item, "".concat(prefix, "[").concat(index, "]")));
        });
        return rows;
    }
    if (value !== null && typeof value === 'object') {
        Object.entries(value).forEach(function (_a) {
            var key = _a[0], val = _a[1];
            var path = prefix ? "".concat(prefix, ".").concat(key) : key;
            rows.push.apply(rows, flattenForExport(val, path));
        });
        return rows;
    }
    if (prefix)
        rows.push([prefix, value]);
    return rows;
};
var getPayloadForExport = function (payload, isReqDocsStage) { return (isReqDocsStage ? asArray(payload === null || payload === void 0 ? void 0 : payload.PricingInfo)[0] : payload); };
var buildTable = function (items, isReqDocsStage, activeStatus) {
    var columns = getGridColumns(isReqDocsStage).map(function (c) { return ({ key: c.key, label: c.label }); });
    var seenColumnKeys = new Set(columns.map(function (c) { return c.key; }));
    var rows = items.map(function (_a) {
        var gridRow = _a.gridRow, payload = _a.payload;
        var gridFields = toResubmitRowViewModel(gridRow, isReqDocsStage);
        var row = __assign({}, gridFields);
        row.status = isReqDocsStage ? (activeStatus !== null && activeStatus !== void 0 ? activeStatus : '--') : 'Failed';
        flattenForExport(getPayloadForExport(payload, isReqDocsStage)).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            row[key] = value;
            if (!seenColumnKeys.has(key)) {
                seenColumnKeys.add(key);
                columns.push({ key: key, label: key });
            }
        });
        return row;
    });
    return { columns: columns, rows: rows };
};
var toCsv = function (columns, rows) {
    var escape = function (value) { return "\"".concat(String(value !== null && value !== void 0 ? value : '').replace(/"/g, '""'), "\""); };
    var lines = __spreadArray([
        columns.map(function (c) { return escape(c.label); }).join(',')
    ], rows.map(function (row) { return columns.map(function (c) { return escape(row[c.key]); }).join(','); }), true);
    return lines.join('\n');
};
var toWorkbook = function (columns, rows) {
    var aoa = __spreadArray([
        columns.map(function (c) { return c.label; })
    ], rows.map(function (row) { return columns.map(function (c) { var _a; return (_a = row[c.key]) !== null && _a !== void 0 ? _a : ''; }); }), true);
    var worksheet = XLSX.utils.aoa_to_sheet(aoa);
    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Applications');
    return workbook;
};
export var exportApplications = function (items, format, isReqDocsStage, activeStatus) {
    if (activeStatus === void 0) { activeStatus = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, columns, rows, filename, buffer;
        return __generator(this, function (_b) {
            if (!items.length)
                return [2];
            _a = buildTable(items, isReqDocsStage, activeStatus), columns = _a.columns, rows = _a.rows;
            filename = "Applications_Export_".concat(new Date().getTime(), ".").concat(format);
            if (format === 'csv') {
                downloadBlob(new Blob([toCsv(columns, rows)], { type: 'text/csv;charset=utf-8;' }), filename);
                return [2];
            }
            buffer = XLSX.write(toWorkbook(columns, rows), { type: 'array', bookType: 'xlsx' });
            downloadBlob(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), filename);
            return [2];
        });
    });
};
